import { defineComponent as _defineComponent } from 'vue'
import ContactSalesDropdown from '@/components/Billing/ContactSalesDropdown.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingPageHeader',
  emits: ["showFAQ"],
  setup(__props, { emit }: { emit: ({ (e: 'showFAQ'): void }), expose: any, slots: any, attrs: any }) {


const plyLogoRedirect = process.env.VUE_APP_APP_URL;

return { __sfc: true,emit, plyLogoRedirect, ContactSalesDropdown }
}

})